import { CheckCircle2, Compass } from "lucide-react";

const QUALIFIED = [
  "Confirmed repayment capacity alongside existing guarantor and collateral checks",
  "Indicative facility size, tenor, and terms generated by the Debt Capacity Advisor",
  "Warm handoff to a designated SACCO credit officer",
  "Response-time SLA committed upfront",
];
const NOT_YET = [
  "Personalised Capital Readiness Report",
  "Shows exactly which checks were not met",
  "Routed into Clinq's readiness-building product",
  "Goal: return as a qualified applicant — cutting both rejections and future defaults",
];

const Column = ({ tone, label, quote, items, Icon, testid }) => {
  const dark = tone === "teal";
  return (
    <div className={`flex flex-col rounded-3xl p-8 sm:p-10 ${dark ? "bg-[#0A8B85] text-white" : "bg-[#F9E9BD] text-[#0B2A28]"}`} data-testid={testid}>
      <div className="flex items-center gap-3">
        <Icon size={22} className={dark ? "text-[#E3B84C]" : "text-[#8A6A1E]"} />
        <span className={`text-[11px] font-extrabold uppercase tracking-[0.22em] ${dark ? "text-[#B9F0EC]" : "text-[#8A6A1E]"}`}>{label}</span>
      </div>
      <p className="mt-5 text-xl font-extrabold leading-snug sm:text-2xl">{quote}</p>
      <ul className="mt-8 space-y-3.5">
        {items.map((t) => (
          <li key={t} className="flex gap-3 text-sm leading-relaxed sm:text-base">
            <CheckCircle2 size={18} className={`mt-0.5 shrink-0 ${dark ? "text-[#E3B84C]" : "text-[#0A8B85]"}`} />
            <span className={dark ? "text-white/90" : "text-[#3A3020]"}>{t}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const SaccoOutcomes = () => (
  <section className="mx-auto max-w-6xl px-5 py-20 sm:py-24" data-testid="sacco-outcomes">
    <h2 className="text-2xl font-extrabold text-[#0B2A28] sm:text-3xl" data-testid="sacco-outcomes-heading">Two Clear Outcomes</h2>
    <div className="mt-10 grid gap-6 md:grid-cols-2">
      <Column tone="teal" label="Qualified" Icon={CheckCircle2} items={QUALIFIED} testid="sacco-outcome-qualified"
        quote="'Good news — you may qualify for a SACCO loan today.'" />
      <Column tone="gold" label="Not Yet Qualified" Icon={Compass} items={NOT_YET} testid="sacco-outcome-not-yet"
        quote="'You are not quite ready yet — here is exactly what to work on.'" />
    </div>
  </section>
);
